var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"article-headlines"},[(_vm.headlines.length)?[_c('HeadlineBlocks',{attrs:{"data":{ items: _vm.headlines },"settings":_vm.settings,"block-type":"BlockType108"}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }